export default defineNuxtPlugin(() => {
  return {
    provide: {
      window: (() => {
        if (import.meta.client)
        { return window; }

        return undefined;
      })(),
    },
  };
});
